import { createFileRoute } from '@tanstack/react-router';
import { GlyphPage } from '@/features/misc/glyph-page';

export const Route = createFileRoute('/glyphs')({ component: GlyphPage });
